(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  function euro(c) { return (Number(c) / 100).toFixed(2).replace('.', ',') + ' €'; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* ---------- Tiroirs (menu des créations + panier) ---------- */
  function setDrawer(root, open, side) {
    if (!root) return;
    root.classList.toggle('pointer-events-auto', open);
    root.classList.toggle('pointer-events-none', !open);
    root.setAttribute('aria-hidden', open ? 'false' : 'true');
    var bd = $('[data-aj-backdrop]', root);
    if (bd) { bd.classList.toggle('opacity-100', open); bd.classList.toggle('opacity-0', !open); }
    var p = $('[data-aj-panel]', root);
    if (p) { var hid = side === 'left' ? '-translate-x-full' : 'translate-x-full'; p.classList.toggle('translate-x-0', open); p.classList.toggle(hid, !open); }
  }
  var menu = $('[data-aj-menu]'), cartEl = $('[data-aj-cart]');

  /* ---------- Panier ---------- */
  function updateCount(n) {
    $$('[data-aj-cart-count]').forEach(function (b) { b.textContent = n; b.classList.toggle('aj-hidden', !n); });
    $$('[data-aj-cart-open]').forEach(function (b) { b.setAttribute('aria-label', 'Panier, ' + n + ' article' + (n === 1 ? '' : 's')); });
  }
  function renderCart(c) {
    updateCount(c.item_count);
    var list = $('[data-aj-cart-items]'), foot = $('[data-aj-cart-footer]');
    if (!list) return;
    if (!c.items.length) {
      list.innerHTML = '<p class="py-16 text-center font-display text-2xl text-ink/50">Ton panier est vide.</p>';
      if (foot) foot.classList.add('aj-hidden');
      return;
    }
    list.innerHTML = c.items.map(function (it) {
      var v = (it.variant_title && it.variant_title !== 'Default Title') ? it.variant_title : 'Pièce artisanale';
      var img = it.image ? '<img src="' + esc(it.image) + '" alt="' + esc(it.product_title) + '" class="aspect-square size-[72px] rounded-[8px] object-cover">' : '<span></span>';
      return '<article class="grid grid-cols-[72px_1fr_auto] gap-3 border-b border-ink/10 py-4">' + img +
        '<div class="min-w-0"><h3 class="font-display text-xl leading-tight">' + esc(it.product_title) + '</h3><p class="mt-1 text-xs text-ink/55">' + esc(v) + '</p><p class="mt-1 text-sm">' + euro(it.final_price) + '</p></div>' +
        '<div class="flex flex-col items-end justify-between"><button type="button" data-aj-qty="0" data-key="' + esc(it.key) + '" class="text-xs text-ink/45 underline">Retirer</button>' +
        '<div class="flex items-center gap-2 rounded-full ring-1 ring-ink/10"><button type="button" data-aj-qty="' + (it.quantity - 1) + '" data-key="' + esc(it.key) + '" class="grid size-7 place-items-center">−</button><span class="w-3 text-center text-xs">' + it.quantity + '</span><button type="button" data-aj-qty="' + (it.quantity + 1) + '" data-key="' + esc(it.key) + '" class="grid size-7 place-items-center">+</button></div></div></article>';
    }).join('');
    if (foot) { foot.classList.remove('aj-hidden'); var t = $('[data-aj-cart-total]'); if (t) t.textContent = euro(c.total_price); }
  }
  function fetchCart() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function openCart() { setDrawer(cartEl, true, 'right'); fetchCart().then(renderCart); }
  function addToCart(id, btn) {
    var label = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; if (btn.hasAttribute('data-aj-busy-label')) btn.textContent = btn.getAttribute('data-aj-busy-label'); }
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }) })
      .then(function (r) { return r.json(); })
      .then(function () { openCart(); })
      .catch(function () {})
      .then(function () { if (btn) { btn.disabled = false; btn.innerHTML = label; } });
  }
  function changeQty(key, qty) {
    return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: Math.max(0, qty) }) })
      .then(function (r) { return r.json(); }).then(renderCart);
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-aj-menu-open],[data-aj-menu-close],[data-aj-cart-open],[data-aj-cart-close],[data-aj-add],[data-aj-qty],[data-aj-checkout]');
    if (!t) return;
    if (t.hasAttribute('data-aj-menu-open')) setDrawer(menu, true, 'left');
    else if (t.hasAttribute('data-aj-menu-close')) setDrawer(menu, false, 'left');
    else if (t.hasAttribute('data-aj-cart-open')) { e.preventDefault(); openCart(); }
    else if (t.hasAttribute('data-aj-cart-close')) setDrawer(cartEl, false, 'right');
    else if (t.hasAttribute('data-aj-add')) { e.preventDefault(); var id = t.getAttribute('data-aj-add'); if (id) addToCart(id, t); }
    else if (t.hasAttribute('data-aj-qty')) { changeQty(t.getAttribute('data-key'), parseInt(t.getAttribute('data-aj-qty'), 10)); }
    else if (t.hasAttribute('data-aj-checkout')) { window.location.href = '/checkout'; }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { setDrawer(menu, false, 'left'); setDrawer(cartEl, false, 'right'); } });
  fetchCart().then(function (c) { updateCount(c.item_count); }).catch(function () {});

  /* ---------- Carrousel d'accueil ---------- */
  $$('[data-aj-carousel]').forEach(function (root) {
    var slides = $$('[data-aj-slide]', root), dots = $$('[data-aj-dot]', root), i = 0, timer;
    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { var on = k === i; s.classList.toggle('opacity-100', on); s.classList.toggle('opacity-0', !on); s.classList.toggle('pointer-events-none', !on); s.setAttribute('aria-hidden', on ? 'false' : 'true'); });
      dots.forEach(function (d, k) { var on = k === i; d.classList.toggle('w-6', on); d.classList.toggle('w-1.5', !on); d.classList.toggle('opacity-50', !on); });
    }
    function restart() { clearInterval(timer); if (slides.length > 1) timer = setInterval(function () { show(i + 1); }, 6500); }
    dots.forEach(function (d, k) { d.addEventListener('click', function () { show(k); restart(); }); });
    restart();
  });

  /* ---------- Familles de senteurs (page Nos créations) ---------- */
  var RULES = {
    gourmandes: /(gourmand|biscuit|madeleine|chocolat|bonbon|caramel|gauffre|crepe|pain d['’]?epice|la belge)/,
    fruitees: /(fruit|pomme d['’]?amour|pomme-?d?amour|pina colada|poire|belle helene|citron|coco|ananas|fraise|framboise|delice gourmande|yummy)/,
    florales: /(floral|fleur|cerisier|coton|oranger|ylang|monoi|tulipe|rose|violette|printemps|lavande)/,
    bouquets: /(bouquet|brin de douceur|sac parfume)/,
    automnales: /(automne|automnal|citrouille|chataigne|herisson|feuille)/,
    halloween: /(halloween|fantome|chaudron|hallow)/,
    noel: /(noel|christmas|sapin|sucre d['’]?orge|gingerbread|p['’]?tit biscuit)/,
    gothiques: /(goth|crane|serpent|ame perdue|hallow|fruit defendu)/,
    decoratives: /(medusa|silencieuse|arcade)/,
    contenants: /(envoutante)/
  };
  var EXCL = {
    noel: /(pomme d['’]?amour|pina colada|la belge)/,
    gourmandes: /(sucre d['’]?orge|p['’]?tit biscuit|christmas|violette|gingerbread)/,
    fruitees: /(fruit defendu)/
  };
  function norm(s) { return String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLocaleLowerCase('fr'); }
  function matchUnivers(card, key) {
    var title = card.getAttribute('data-title') || '', handle = (card.getAttribute('data-handle') || '').replace(/-/g, ' '), tags = card.getAttribute('data-tags') || '';
    var text = norm([title, handle, tags].join(' ')), name = norm(title + ' ' + handle);
    var isB = /(bouquet|brin de douceur|rose velours|douceur du printemps)/.test(name);
    if (key === 'bouquets') return isB;
    if (isB) return false;
    if (EXCL[key] && EXCL[key].test(text)) return false;
    return RULES[key] ? RULES[key].test(text) : false;
  }
  var coll = $('[data-aj-collection]');
  if (coll) {
    var U = JSON.parse(($('#aj-univers') || {}).textContent || '[]');
    var key = new URLSearchParams(window.location.search).get('univers');
    var active = U.filter(function (u) { return u.key === key; })[0];
    var cards = $$('[data-aj-card]', coll);
    $$('[data-aj-univers-count]').forEach(function (el) {
      var n = cards.filter(function (c) { return matchUnivers(c, el.getAttribute('data-aj-univers-count')); }).length;
      el.textContent = n + ' création' + (n > 1 ? 's' : '');
    });
    if (active) {
      var ti = $('[data-aj-coll-title]'), intro = $('[data-aj-coll-intro]'), grid = $('[data-aj-univers-grid]');
      if (ti) ti.textContent = active.titre;
      if (intro) intro.textContent = active.intro;
      if (grid) grid.classList.add('aj-hidden');
      var shown = 0;
      cards.forEach(function (c) { var m = matchUnivers(c, key); c.classList.toggle('aj-hidden', !m); if (m) shown++; });
      if (!shown) { var em = $('[data-aj-empty]'); if (em) em.classList.remove('aj-hidden'); var gr = $('[data-aj-grid]'); if (gr) gr.classList.add('aj-hidden'); }
      $$('[data-aj-filter]').forEach(function (a) {
        var on = a.getAttribute('data-aj-filter') === key;
        a.classList.toggle('text-or', on); a.classList.toggle('text-ink/60', !on);
        if (on) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current');
      });
    }
  }

  /* ---------- Fiche produit ---------- */
  function decode(t) {
    var d = document.createElement('textarea'); d.innerHTML = t; return d.value;
  }
  function toText(html) { return decode(String(html).replace(/<[^>]+>/g, '')).replace(/\s+/g, ' ').trim(); }
  function cleanHtml(h) { return String(h || '').replace(/<style[\s\S]*?<\/style>/gi, '').replace(/<script[\s\S]*?<\/script>/gi, '').replace(/<svg[\s\S]*?<\/svg>/gi, '').replace(/<input[^>]*>/gi, ''); }
  function parseBlocks(html) {
    var blocks = [], re = /<(p|ul|ol|h[1-6])\b[^>]*>([\s\S]*?)<\/\1>/gi, m;
    while ((m = re.exec(html))) {
      var tag = m[1].toLowerCase(), inner = m[2] || '';
      if (tag === 'ul' || tag === 'ol') {
        var items = [], lm, lre = /<li\b[^>]*>([\s\S]*?)<\/li>/gi;
        while ((lm = lre.exec(inner))) { var tx = toText(lm[1]); if (tx) items.push(tx); }
        if (items.length) blocks.push({ type: 'list', items: items });
        continue;
      }
      var head, body = inner.trim(), em = /^<(em|i)\b[^>]*>[\s\S]*<\/\1>$/i.test(body);
      var strong = body.match(/^<(strong|b)\b[^>]*>([\s\S]*?)<\/\1>\s*(?:<br\s*\/?>|$)/i);
      if (strong) { head = toText(strong[2]).replace(/\s*:$/, ''); body = body.slice(strong[0].length); }
      var lines = body.split(/<br\s*\/?>/i).map(toText).filter(Boolean);
      if (head && !lines.length && tag.charAt(0) === 'h') blocks.push({ type: 'p', head: head, lines: [] });
      else if (head || lines.length) blocks.push({ type: 'p', head: head, lines: lines, em: em && !head });
    }
    return blocks;
  }
  function tabIdFromLabel(l) { if (/descr/i.test(l)) return 'description'; if (/compo/i.test(l)) return 'composition'; if (/conseil|br[uû]l/i.test(l)) return 'conseils'; return null; }
  function blockText(b) { return b.type === 'list' ? b.items.join(' ') : [b.head].concat(b.lines).filter(Boolean).join(' '); }
  function cap(v) { return v.charAt(0).toUpperCase() + v.slice(1); }
  function parseProductContent(desc) {
    var html = cleanHtml(desc), panels = {};
    if (/class="aj-tab-panel"/.test(html)) {
      var navM = html.match(/class="aj-tabs-nav"[^>]*>([\s\S]*?)<\/div>/i), nav = navM ? navM[1] : '';
      var labels = [], lm, lre = /<label\b[^>]*>([\s\S]*?)<\/label>/gi;
      while ((lm = lre.exec(nav))) labels.push(toText(lm[1]));
      var contents = [], cm, cre = /<div class="aj-tab-panel"[^>]*>([\s\S]*?)<\/div>/gi;
      while ((cm = cre.exec(html))) contents.push(cm[1] || '');
      contents.forEach(function (c, i) {
        var id = tabIdFromLabel(labels[i] || '') || ['description', 'composition', 'conseils'][i];
        if (id) panels[id] = (panels[id] || []).concat(parseBlocks(c));
      });
    } else {
      panels.description = parseBlocks(html.replace(/<div class="aj-notes"[\s\S]*?<\/div>\s*<\/div>\s*<\/div>/i, ''));
    }
    var description = panels.description || [], composition = panels.composition || [], conseils = panels.conseils || [];
    var found = {}, noteLine = /^[^A-Za-zÀ-ÿ]*(T[êe]te|C[œo]e?ur|Fond)\s*:\s*(.+)$/i;
    description.forEach(function (b) {
      if (b.type !== 'p') return;
      b.lines.forEach(function (line) {
        var m = line.match(noteLine);
        if (m) { var k = /^t/i.test(m[1]) ? 'Tête' : /^c/i.test(m[1]) ? 'Cœur' : 'Fond'; if (!found[k]) found[k] = m[2].trim().replace(/\s*\.$/, ''); }
      });
    });
    var notes = null;
    if (found['Tête'] && found['Cœur'] && found['Fond']) {
      notes = ['Tête', 'Cœur', 'Fond'].map(function (t) { return { titre: t, notes: found[t].split(/\s*,\s*/).filter(Boolean).map(cap).join(' · ') }; });
      description = description.map(function (b) { return b.type === 'p' ? { type: 'p', head: b.head, em: b.em, lines: b.lines.filter(function (l) { return !noteLine.test(l); }) } : b; })
        .filter(function (b) { if (b.type !== 'p') return true; var t = blockText(b); if (!t) return false; return !/^(notes olfactives|pyramide olfactive)\s*:?$/i.test(t); });
    }
    if (!panels.composition) {
      var moved = description.filter(function (b) { return /^composition\b/i.test(blockText(b)); });
      if (moved.length) { composition = moved; description = description.filter(function (b) { return moved.indexOf(b) < 0; }); }
    }
    composition = composition.filter(function (b, i) { return !(i === 0 && b.type === 'p' && !b.lines.length && /^composition$/i.test(b.head || '')); });
    var intro = null, first = description[0];
    if (first && first.type === 'p' && !first.head && first.lines.join(' ').length >= 40) { intro = first.lines.join(' '); description = description.slice(1); }
    var tabs = [];
    if (description.length) tabs.push({ id: 'description', label: 'Description', blocks: description });
    if (composition.length) tabs.push({ id: 'composition', label: 'Composition', blocks: composition });
    if (conseils.length) tabs.push({ id: 'conseils', label: 'Conseils de brûlage', blocks: conseils });
    return { intro: intro, notes: notes, tabs: tabs };
  }
  function lines(ls) { return ls.map(function (l, i) { return (i ? '<br>' : '') + '<span>' + esc(l) + '</span>'; }).join(''); }
  function renderDescription(blocks) {
    return blocks.map(function (b, i) {
      var first = i === 0;
      if (b.type === 'list') return '<ul class="' + (first ? 'space-y-2' : 'mt-6 space-y-2') + '">' + b.items.map(function (it) { return '<li class="flex gap-3"><span class="text-or">◆</span>' + esc(it) + '</li>'; }).join('') + '</ul>';
      if (b.em) return '<p class="' + (first ? '' : 'mt-6 ') + 'font-display text-3xl italic leading-snug text-ink/85 md:text-[2.1rem]">' + lines(b.lines) + '</p>';
      if (first && !b.head && b.lines.join(' ').length >= 80) return '<p class="font-display text-2xl italic leading-9 text-ink/80">' + lines(b.lines) + '</p>';
      return '<p class="' + (first ? '' : 'mt-6') + '">' + (b.head ? '<strong class="font-medium text-ink">' + esc(b.head) + '</strong>' : '') + (b.head && b.lines.length ? '<br>' : '') + lines(b.lines) + '</p>';
    }).join('');
  }
  function renderComposition(blocks) {
    return blocks.map(function (b, i) {
      if (b.type === 'list') return '<ul class="' + (i === 0 ? 'space-y-3' : 'mt-6 space-y-3') + '">' + b.items.map(function (it) { return '<li class="flex gap-3"><span class="text-or">◆</span><span>' + esc(it) + '</span></li>'; }).join('') + '</ul>';
      if (b.head && /^(attention|informations de s[ée]curit[ée].*)$/i.test(b.head)) return '<p class="mt-8 border-l-2 border-or/40 pl-4 text-xs leading-6 text-ink/55">' + (/^attention$/i.test(b.head) ? '' : '<strong class="font-medium text-ink">' + esc(b.head) + '</strong><br>') + lines(b.lines) + '</p>';
      return '<p class="' + (i === 0 ? '' : 'mt-6') + '">' + (b.head ? '<strong class="font-medium text-ink">' + esc(b.head) + '</strong>' : '') + (b.head && b.lines.length ? '<br>' : '') + lines(b.lines) + '</p>';
    }).join('');
  }
  function renderConseils(blocks) {
    return '<div class="grid gap-8 sm:grid-cols-2">' + blocks.map(function (b) {
      if (b.type === 'list') return '<div><ul class="space-y-2">' + b.items.map(function (it) { return '<li class="flex gap-3"><span class="text-or">◆</span>' + esc(it) + '</li>'; }).join('') + '</ul></div>';
      return '<div>' + (b.head ? '<h3 class="font-display text-xl">' + esc(b.head) + '</h3>' : '') + (b.lines.length ? '<p class="' + (b.head ? 'mt-2' : '') + '">' + lines(b.lines) + '</p>' : '') + '</div>';
    }).join('') + '</div>';
  }
  var pp = $('[data-aj-product]');
  if (pp) {
    var descEl = $('#aj-desc'), content = parseProductContent(descEl ? descEl.innerHTML : '');
    var introEl = $('[data-aj-intro]');
    if (introEl && content.intro) { introEl.textContent = content.intro; introEl.classList.remove('aj-hidden'); }
    var notesEl = $('[data-aj-notes]');
    if (notesEl && content.notes) {
      var T = ['bg-framboise/15', 'bg-or/15', 'bg-[color-mix(in_oklab,var(--or)_8%,var(--ivoire))]'];
      notesEl.innerHTML = '<p class="text-[10px] uppercase tracking-[0.22em] text-ink/55">Notes olfactives</p><div class="mt-3 grid grid-cols-3 gap-3">' + content.notes.map(function (n, i) { return '<div class="' + T[i] + ' px-3 py-4 text-center"><strong class="block font-display text-base font-normal">' + esc(n.titre) + '</strong><span class="mt-1 block text-[10px] leading-4 text-ink/60">' + esc(n.notes) + '</span></div>'; }).join('') + '</div>';
      notesEl.classList.remove('aj-hidden');
    }
    var tabsEl = $('[data-aj-tabs]');
    if (tabsEl && content.tabs.length) {
      var navEl = $('[data-aj-tabs-nav]', tabsEl), bodyEl = $('[data-aj-tabs-body]', tabsEl);
      var showTab = function (id) {
        var tab = content.tabs.filter(function (t) { return t.id === id; })[0] || content.tabs[0];
        navEl.innerHTML = content.tabs.map(function (t) { return '<button type="button" data-aj-tab="' + t.id + '" class="nav-gold text-xs uppercase tracking-[0.2em] md:text-[13px] ' + (t.id === tab.id ? 'text-or' : 'text-ink/55') + '">' + esc(t.label) + '</button>'; }).join('');
        bodyEl.innerHTML = tab.id === 'description' ? renderDescription(tab.blocks) : tab.id === 'composition' ? renderComposition(tab.blocks) : renderConseils(tab.blocks);
      };
      navEl.addEventListener('click', function (e) { var b = e.target.closest('[data-aj-tab]'); if (b) showTab(b.getAttribute('data-aj-tab')); });
      showTab('description');
      tabsEl.classList.remove('aj-hidden');
    }
    /* Variantes en pastilles */
    var data = JSON.parse(($('#aj-product-json') || {}).textContent || '{}');
    var variants = data.variants || [], options = data.options || [];
    var current = variants.filter(function (v) { return v.id === data.selected; })[0] || variants[0];
    var priceEl = $('[data-aj-price]'), addBtn = $('[data-aj-add-main]');
    function optionLabel(name, values) {
      var k = name.trim().toLowerCase();
      if (/combus|heure/.test(k) || values.every(function (v) { return /^\d+\s*h?$/i.test(v.trim()); })) return 'Durée de combustion';
      if (/parfum|fragrance/.test(k)) return 'Parfum';
      if (/couleur|coloris/.test(k)) return 'Couleur';
      if (/taille/.test(k)) return 'Taille';
      if (/d[ée]gressif|quantit/.test(k)) return 'Quantité';
      if (k === 'choix') return 'Couleur';
      return cap(name.trim());
    }
    $$('[data-aj-legend]').forEach(function (lg, i) { var o = options[i]; if (o) lg.textContent = optionLabel(o.name, o.values); });
    function findVariant(sel) { return variants.filter(function (v) { return v.options.every(function (val, i) { return sel[i] === val; }); })[0]; }
    function refresh() {
      var sel = current ? current.options.slice() : [];
      $$('[data-aj-pill]').forEach(function (b) {
        var oi = parseInt(b.getAttribute('data-oi'), 10), val = b.getAttribute('data-val');
        var cand = sel.slice(); cand[oi] = val; var cv = findVariant(cand), on = sel[oi] === val;
        b.disabled = !cv; b.setAttribute('aria-pressed', on ? 'true' : 'false');
        b.className = 'inline-flex items-center justify-center gap-2 whitespace-nowrap font-medium cursor-pointer transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 disabled:cursor-not-allowed border h-8 text-xs min-w-fit rounded-full bg-background px-4 shadow-none ' + (on ? 'border-framboise text-framboise hover:bg-framboise/5 hover:text-framboise' : 'hover:text-accent-foreground border-ink/15 text-ink/70 hover:border-framboise/50 hover:bg-framboise/5');
        b.textContent = val + (cv && !cv.available ? ' · épuisé' : '');
      });
      if (priceEl) priceEl.textContent = current ? euro(current.price) : 'Indisponible';
      if (addBtn) { addBtn.setAttribute('data-aj-add', current ? current.id : ''); addBtn.disabled = !current || !current.available; }
    }
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-aj-pill]'); if (!b || !current) return;
      var sel = current.options.slice(); sel[parseInt(b.getAttribute('data-oi'), 10)] = b.getAttribute('data-val');
      var v = findVariant(sel); if (v) { current = v; refresh(); }
    });
    refresh();
    /* Galerie */
    var main = $('[data-aj-main-img]');
    $$('[data-aj-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        if (main) main.src = t.getAttribute('data-src');
        $$('[data-aj-thumb]').forEach(function (o) { var on = o === t; o.classList.toggle('border-or', on); o.classList.toggle('border-or/20', !on); o.classList.toggle('opacity-60', !on); o.classList.toggle('hover:opacity-100', !on); });
      });
    });
  }

  /* ---------- Formulaires (Contact, Professionnels) ---------- */
  $$('form[data-aj-mailto]').forEach(function (f) {
    f.addEventListener('submit', function (e) {
      e.preventDefault();
      var d = new FormData(f), g = function (k) { return String(d.get(k) || ''); }, subject, body;
      if (f.getAttribute('data-aj-mailto') === 'pro') {
        subject = "Demande d'accès pro — " + g('societe');
        body = 'Nom et prénom : ' + g('nom') + '\nSociété : ' + g('societe') + '\nE-mail : ' + g('email') + '\nTéléphone : ' + g('tel') + '\nSIRET / type d’activité : ' + g('siret') + '\n\nMessage :\n' + g('message');
      } else {
        subject = 'Message de ' + g('nom');
        body = g('message') + '\n\n' + g('nom') + ' — ' + g('email');
      }
      window.location.href = 'mailto:contact@ajouba.com?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(body);
    });
  });

  /* ---------- Protection des textes et images ---------- */
  function ok(n) { var el = n && (n.nodeType === 1 ? n : n.parentElement); return !!(el && el.closest && el.closest('input,textarea,select,[contenteditable],.aj-policy')); }
  document.addEventListener('contextmenu', function (e) { if (!ok(e.target)) e.preventDefault(); });
  document.addEventListener('dragstart', function (e) { if (e.target && e.target.tagName === 'IMG') e.preventDefault(); });
  document.addEventListener('copy', function (e) { var s = window.getSelection(); if (ok(document.activeElement) || (s && ok(s.anchorNode))) return; e.preventDefault(); });
  document.addEventListener('cut', function (e) { if (!ok(document.activeElement)) e.preventDefault(); });

  /* ---------- Halo du curseur ---------- */
  var glow = $('[data-aj-glow]');
  if (glow && window.matchMedia('(pointer: fine)').matches) {
    window.addEventListener('mousemove', function (e) { glow.style.transform = 'translate(' + e.clientX + 'px,' + e.clientY + 'px)'; }, { passive: true });
  }
})();